/* © 2026 MINOTI Sp. z o.o. Wszelkie prawa zastrzeżone. Licencja: MINOTI Sp. z o.o. Autor: Adam Kulesza (8442055806). */
/*
  MINOTI AW26 — rozmiar z adresu ?variant= (11.09.2026)

  PROBLEM. Reklamy Google Shopping, Meta i darmowe wizytowki w Merchant Center
  prowadza na adres z konkretnym wariantem: /products/...?variant=56559148663115.
  Sekcja minoti-product wstawiala ten wariant do ukrytego pola formularza, ale
  nie zaznaczala go w panelu rozmiarow. Straznik formularza patrzy na
  root.dataset.mnpPicked, wiec pierwsze klikniecie DODAJ DO KOSZYKA konczylo sie
  komunikatem „Najpierw wybierz rozmiar", mimo ze rozmiar byl w adresie.
  Klient z platnego ruchu dostawal blad na pierwszym kliknieciu.

  ROZWIAZANIE. Po zaladowaniu strony szukamy wiersza rozmiaru o tym samym
  data-id i klikamy w niego. Klikniecie przechodzi przez wlasny handler sekcji
  (choose), wiec cala reszta — cena, etykieta, ukryte pole, mnpPicked — ustawia
  sie jednym torem. Zero powielonej logiki.

  Wariant nieistniejacy: nie robimy nic, klient wybiera sam. Wariant wyprzedany:
  zaznaczamy go (patrz nizej), sekcja pokazuje, ze go nie ma.

  20.10.2026 (runda 19):
  - Wybor rozmiaru zapisuje sie w adresie (?variant=ID) przez history.replaceState.
    Skopiowany albo udostepniony link otwiera ten sam rozmiar, a odswiezenie strony
    go nie gubi. replaceState, nie pushState: przycisk Wstecz dalej wraca na
    poprzednia strone, a nie przez kazdy klikniety rozmiar.
  - Przy „ogranicz ruch” (prefers-reduced-motion) przewijanie na karcie produktu
    jest natychmiastowe. Sekcja w jednym miejscu wola scrollIntoView z
    behavior:'smooth' bez sprawdzenia tego ustawienia; tu zamieniamy 'smooth' na
    'auto' dla scrollIntoView, scrollTo i scrollBy.
*/

(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function calm(opts) {
    if (!reduce || !reduce.matches || !opts || typeof opts !== 'object') return opts;
    if (opts.behavior !== 'smooth') return opts;
    var copy = {};
    for (var k in opts) copy[k] = opts[k];
    copy.behavior = 'auto';
    return copy;
  }

  function wrap(proto, name) {
    var orig = proto && proto[name];
    if (typeof orig !== 'function' || orig.__mnCalm) return;
    var fn = function (a, b) {
      if (arguments.length === 1) return orig.call(this, calm(a));
      return orig.apply(this, arguments);
    };
    fn.__mnCalm = true;
    proto[name] = fn;
  }

  wrap(Element.prototype, 'scrollIntoView');
  wrap(Element.prototype, 'scrollTo');
  wrap(Element.prototype, 'scrollBy');
  wrap(window, 'scrollTo');
  wrap(window, 'scrollBy');

  function remember(id) {
    if (!id || !window.history || !history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') === id) return;
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url.toString());
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var row = event.target && event.target.closest ? event.target.closest('[data-mnp-size-option][data-id]') : null;
    if (!row) return;
    remember(String(row.getAttribute('data-id') || '').replace(/[^0-9]/g, ''));
  });

  function pick() {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (!id) return;

    var row = document.querySelector('[data-mnp-size-option][data-id="' + id.replace(/[^0-9]/g, '') + '"]');
    if (!row) return;
    /* 16.10.2026 — audyt C #40: wyprzedany wariant z reklamy tez zaznaczamy.
       Sekcja wypisuje wtedy w polu „128 — sold out”, wiec rodzic od razu wie,
       ze jego rozmiaru nie ma, zamiast widziec pusty wybor. */

    var root = row.closest('[data-mnp-root]') || row.closest('.mnp');
    if (root && root.dataset.mnpPicked === '1') return;

    row.click();

    /* Panel rozmiarow sam sie zamyka po wyborze — zeby strona nie otwierala sie
       z rozwinieta lista, gdy handler sekcji jeszcze nie zdazyl sie podpiac. */
    var panel = root && root.querySelector('[data-mnp-size-panel]');
    if (panel) panel.hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pick);
  } else {
    pick();
  }
})();
